import DesktopHelpers from 'helpers/DesktopHelpers'
import { WindowsIcon } from 'components/Utils/Icons'
import React from 'react'

export const createShortcutHelper = shortcut => {
  return shortcut
    .replace('cmd', DesktopHelpers.isMac() ? '⌘' : 'Ctrl')
    .replace('shift', '⇧')
    .replace('enter', '⏎')
    .replace('left', '←')
    .replace('right', '→')
    .split('+')
}

const createEmojiHelper = () => {
  if (DesktopHelpers.isMac()) {
    return 'Ctrl+⌘+Space'
  }
  return (
    <React.Fragment>
      <WindowsIcon /> {/* There is no windows character so we need an svg*/}
      {'+.'}
    </React.Fragment>
  )
}

// Application level
export const createNote = createShortcutHelper(
  DesktopHelpers.isAppDesktop() ? 'cmd+N' : 'Alt+N'
)
export const toggleChannelsList = createShortcutHelper('cmd+shift+E')
export const toggleSearch = createShortcutHelper('cmd+shift+K')
export const quickSwitch = createShortcutHelper('cmd+K')
export const toggleSearchInDoc = createShortcutHelper('cmd+F')
export const navigateBackward = createShortcutHelper('cmd+left')
export const navigateForward = createShortcutHelper('cmd+right')
export const esc = createShortcutHelper('Esc')
// Editor
export const toggleBold = createShortcutHelper('cmd+B')
export const toggleHighlight = createShortcutHelper('cmd+E')
export const toggleItalic = createShortcutHelper('cmd+I')
export const toggleUnderline = createShortcutHelper('cmd+U')
export const toggleStrikethrough = createShortcutHelper('cmd+shift+S')
export const toggleInlineCode = createShortcutHelper('cmd+J')
export const toggleAddLink = createShortcutHelper('cmd+K')
export const toggleH1 = createShortcutHelper('cmd+shift+1')
export const toggleH2 = createShortcutHelper('cmd+shift+2')
export const toggleH3 = createShortcutHelper('cmd+Alt+3')
export const toggleOrderedList = createShortcutHelper('cmd+shift+7')
export const toggleUnorderedList = createShortcutHelper('cmd+shift+8')
export const toggleCodeBlock = createShortcutHelper('cmd+shift+9')
export const toggleQuoteBlock = createShortcutHelper('cmd+shift+>')
export const toggleHintBlock = createShortcutHelper('cmd+shift+Alt+H')
export const toggleTodo = createShortcutHelper('cmd+shift+C')
export const toggleEmbed = createShortcutHelper('cmd+shift+E')
export const togglePlaceholder = createShortcutHelper('cmd+Alt+P')
export const toggleComment = createShortcutHelper('cmd+Alt+M')
export const checkTodo = createShortcutHelper('cmd+Enter')
export const indentList = createShortcutHelper('Tab')
export const undentList = createShortcutHelper('shift+Tab')
export const undo = createShortcutHelper('cmd+Z')
export const redo = createShortcutHelper('cmd+shift+Z')
export const reloadPage = createShortcutHelper('cmd+R')
export const addEmoji = createEmojiHelper()
// Comments
export const commentFastSend = createShortcutHelper('cmd+⏎')

const ShortcutHelpers = {
  createNote,
  toggleChannelsList,
  toggleSearch,
  toggleSearchInDoc,
  quickSwitch,
  navigateBackward,
  navigateForward,
  esc,
  toggleBold,
  toggleHighlight,
  toggleItalic,
  toggleUnderline,
  toggleStrikethrough,
  toggleInlineCode,
  toggleAddLink,
  toggleH1,
  toggleH2,
  toggleH3,
  toggleOrderedList,
  toggleUnorderedList,
  toggleCodeBlock,
  toggleQuoteBlock,
  toggleHintBlock,
  toggleTodo,
  checkTodo,
  togglePlaceholder,
  toggleComment,
  toggleEmbed,
  indentList,
  undentList,
  undo,
  redo,
  addEmoji,
  commentFastSend,
  reloadPage,
}

export default ShortcutHelpers
